<template>
    <!-- Hero Sections Here -->
   <section class="banner__breadcumn ralt">

<!--Search Popup-->
<div id="searchPopup" class="search__popup">
   <form action="#" class="popup-content d-flex align-items-center">
      <input type="text" placeholder="Search Here">
      <button id="closeButton">
         <i class="bi bi-x-lg"></i>
      </button>
   </form>
</div>
<!--Search Popup-->

<div class="breadcumnd__wrapper">
   <div class="container">
      <div class="profile__wrapper">
         <div class="row g-4 align-items-center justify-content-between">
            <div class="col-xxl-6 col-xl-6 col-lg-7 col-md-7 col-sm-7">
               <div class="breadcumnd__content">
                  <span class="d41 mb-24">
                     Chat-bot
                  </span>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
</section>
<!-- Hero Section End -->
<br>
<br>
<br>
<br>
<br>
<br>

<!-- chat section here -->
<section class="chat__section pb-120">
<div class="container">
   <div class="chat__uswrapper border bgwhite overhid round16">
      <div class="row g-0 p-0 justify-content-center">
         <div class="col-xl-4 col-lg-4">
            <div class="chat__user__wrapper">
               <div class="cheat__user d-flex mb-30 align-items-center justify-content-between">
                  <img src="assets/img/bn/profile.jpg" class="uericon round50" alt="icon">
                  <div class="edit__user d-flex align-items-center gap-3">
                     <a href="javascript:void(0)">
                        <i class="bi bi-pencil title fz-18"></i>
                     </a>
                     <div class="dropend">
                        <button type="button" class="dropdown-btn bg-transparent" data-bs-toggle="dropdown"
                           aria-expanded="false">
                           <i class="bi bi-three-dots-vertical fz-18 title"></i>
                        </button>
                        <!-- <ul class="dropdown-menu">
                           <li>
                              <a class="droplist d-flex align-items-center gap-2" href="#">
                                 <i class="material-symbols-outlined mat-icon"> person_remove </i>
                                 <span>Unfollow</span>
                              </a>
                           </li>
                           <li>
                              <a class="droplist d-flex align-items-center gap-2" href="#">
                                 <i class="material-symbols-outlined mat-icon"> hide_source </i>
                                 <span>Hide Contact</span>
                              </a>
                           </li>
                        </ul> -->
                     </div>
                  </div>
               </div>
               <div class="chat__search border mb-30 d-flex align-items-center justify-content-between">
                  <input type="text" placeholder="Izlash">
                  <i class="bi bi-search search__icon"></i>
               </div>
               <div class="chat__llist">
                  <a href="javascript:void(0)"
                     class="text-start mb-30 d-flex align-items-center justify-content-between chat__single">
                     <span class="d-flex gap-3 align-items-center">
                        <span class="avatar red">
                           <img class="avatar-img" src="assets/img/testimonial/name1.jpg" alt="avatar">
                        </span>
                        <span class="text-area">
                           <span class="m-0 fz-16 d-block title mb-1 fw-600"> Tereza Uebb </span>
                           <span class="mdtxt fz-12 inter d-block fw-400">faqat keyingi safar uchun
                              g'oyalar</span>
                        </span>
                     </span>
                     <span class="date__time">
                        <span class="bg d-flex align-items-center justify-content-center">
                           1
                        </span>
                        <span class="mnutes mactive fz-12 inter fw-400">
                           4m
                        </span>
                     </span>
                  </a>
                  <a href="javascript:void(0)"
                     class="text-start mb-30 d-flex align-items-center justify-content-between chat__single">
                     <span class="d-flex gap-3 align-items-center">
                        <span class="avatar red">
                           <img class="avatar-img" src="assets/img/testimonial/name2.jpg" alt="avatar">
                        </span>
                        <span class="text-area">
                           <span class="m-0 fz-16 d-block mb-1 title fw-600">Bessi Kuper</span>
                           <span class="mdtxt fz-12 inter d-block fw-400">oh, bu ajoyib</span>
                        </span>
                     </span>
                     <span class="date__time">
                        <span class="bg d-flex align-items-center justify-content-center">
                           27
                        </span>
                        <span class="mnutes mactive fz-12 inter fw-400">
                           3m
                        </span>
                     </span>
                  </a>
                  <a href="javascript:void(0)"
                     class="text-start mb-30 d-flex align-items-center justify-content-between chat__single">
                     <span class="d-flex gap-3 align-items-center">
                        <span class="avatar red">
                           <img class="avatar-img" src="assets/img/testimonial/name3.jpg" alt="avatar">
                        </span>
                        <span class="text-area">
                           <span class="m-0 fz-16 d-block mb-1 title fw-600"> Ralf Edvards </span>
                           <span class="mdtxt fz-12 inter d-block fw-400">Siz: mukammal!</span>
                        </span>
                     </span>
                     <span class="date__time">
                        <span class="bg d-flex align-items-center justify-content-center">
                           7
                        </span>
                        <span class="mnutes mactive fz-12 inter fw-400">
                           32m
                        </span>
                     </span>
                  </a>
                  <a href="javascript:void(0)"
                     class="text-start mb-30 d-flex align-items-center justify-content-between chat__single">
                     <span class="d-flex gap-3 align-items-center">
                        <span class="avatar gactive">
                           <img class="avatar-img" src="assets/img/testimonial/name4.jpg" alt="avatar">
                        </span>
                        <span class="text-area">
                           <span class="fz-16 title inter d-block mb-1 fw-600">Jerom Bell</span>
                           <span class="mdtxt fz-12 inter d-block fw-400 prag">vouuuu</span>
                        </span>
                     </span>
                     <span class="date__time">
                        <span class="mnutes prag fz-14 inter fw-400">
                           1h
                        </span>
                     </span>
                  </a>
                  <a href="javascript:void(0)"
                     class="text-start mb-30 d-flex align-items-center justify-content-between chat__single">
                     <span class="d-flex gap-3 align-items-center">
                        <span class="avatar gactive">
                           <img class="avatar-img" src="assets/img/testimonial/name5.jpg" alt="avatar">
                        </span>
                        <span class="text-area">
                           <span class="fz-16 title inter d-block mb-1 fw-600">Floyd Miles</span>
                           <span class="mdtxt fz-12 inter d-block fw-400 prag">Siz: Voy, bu haqiqatan ham</span>
                        </span>
                     </span>
                     <span class="date__time">
                        <span class="mnutes prag fz-14 inter fw-400">
                           1 soat
                        </span>
                     </span>
                  </a>

               </div>
            </div>
         </div>
         <div class="col-xl-8 col-lg-8">
            <div class="chat__box__view">
               <div class="chat__person">
                  <div class="cheat__user d-flex align-items-center justify-content-between">
                     <div class="d-flex align-items-center gap-3">
                        <div class="user__avatar d-flex align-items-center gap-3 red">
                           <img src="assets/img/frelancer/f11.png" class="uericon round50" alt="icon">
                        </div>
                        <span class="fz-20 fw-600 inter pra">
                           Lois Lane
                        </span>
                     </div>
                     <div class="edit__user d-flex align-items-center gap-3">
                        <a href="javascript:void(0)">
                           <i class="bi bi-telephone fz-18 pra"></i>
                        </a>
                        <a href="javascript:void(0)">
                           <i class="bi bi-camera-video fz-18 pra"></i>
                        </a>
                     </div>
                  </div>
               </div>
               <div class="chat__body pb-16">
                  <div class="chat__body__inner d-flex justify-content-between">
                     <ul class="left__side__chtat">
                        <li class="pb-80">
                           <span class="man mb-30">
                              <img src="assets/img/bn/profile.jpg" alt="darlene">
                           </span>
                           <span class="textbg topbefore">
                              Salom
                           </span>
                        </li>
                        <li class="pb-80">
                           <span class="man mb-30">
                              <img src="assets/img/bn/profile.jpg" alt="darlene">
                           </span>
                           <span class="textbg">
                              Qanday yordam kerak
                           </span>
                        </li>
                        <li class="pb-80">
                           <span class="man mb-30">
                              <img src="assets/img/bn/profile.jpg" alt="darlene">
                           </span>
                           <span class="textbg">
                              Tracking raqamingizni yuboring
                           </span>
                        </li>
                     </ul>
                     <ul class="left__side__chtat pt-120 right__side__chats">
                        <li>
                           <span class="textbg">
                              Vaaleykum assalom
                           </span>
                           <span class="man mt-30">
                              <img src="assets/img/frelancer/f11.png" alt="darlene">
                           </span>
                        </li>
                        <li class="pt-80">
                           <span class="textbg">
                              Tracking aqida ma'lumot bering
                           </span>
                           <span class="man mt-30">
                              <img src="assets/img/frelancer/f11.png" alt="darlene">
                           </span>
                        </li>
                        <li class="pt-80">
                           <span class="textbg">
                              CB055083061RU
                           </span>
                           <span class="man mt-30">
                              <img src="assets/img/frelancer/f11.png" alt="darlene">
                           </span>
                        </li>
                     </ul>
                  </div>
               </div>
               <div class="chat__view__footer d-flex align-items-center">
                  <div class="addfile__left d-flex align-items-center gap-3">
                     <span class="file__choose">
                        <i class="bi bi-plus-circle pra fz-18"></i>
                        <input type="file">
                     </span>
                     <a href="javascript:void(0)">
                        <i class="bi bi-mic"></i>
                     </a>
                     <a href="javascript:void(0)">
                        <i class="bi bi-camera"></i>
                     </a>
                     <a href="javascript:void(0)">
                        <i class="bi bi-emoji-heart-eyes"></i>
                     </a>
                  </div>
                  <form action="#" class="d-flex round100 border align-items-center justify-content-between">
                     <input type="text" placeholder="Xabar yozing...">
                     <button type="submit" class="cmn__btn">
                        <span>
                           <i class="bi bi-send"></i>
                        </span>
                     </button>
                  </form>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
</section>
<!-- chat section End -->
</template>